import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OurServicesComponent } from './our-services/our-services.component';
import { TestLoginComponent } from './test-login/test-login.component';
import { SelfcareComponent } from './selfcare/selfcare.component';
import { DisplayComponent } from './public/components/display/display.component';
import { LandingComponent } from './landing/landing.component';

const routes: Routes = [
  { path: '', component: LandingComponent, pathMatch: 'full' },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule) },
  { path: 'testlogin', component: TestLoginComponent },
  { path: 'wordpress/szervizeink', component: OurServicesComponent },
  { path: 'selfcare/:ids', component: SelfcareComponent },
  { path: 'display/:id', component: DisplayComponent },

  { path: '**', component: LandingComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
